"use strict";

module.exports = {
  SUBMIT_TRANSACTION_TIMEOUT: 60 * 10000,
  SIGNATURE_VALID_SEC: 60 * 60 * 24 * 3
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/tokend-js-sdk/lib/const.js
// module id = GJTv
// module chunks = 0